import { Utils } from "@/plugin/gis-viewer/Utils";
import { loadModules } from "esri-loader";
import * as THREE from "three";
import { OBJLoader } from "three-obj-mtl-loader";
import { GetSpeed } from "./distance";

export default class TrackPlayRender {
  private view: any;
  private renderer: any; // three.js renderer
  private camera: any; // three.js camera
  private scene: any; // three.js scene

  private ambient: any; // three.js ambient light source
  private sun: any; // three.js sun light source
  private start: boolean = false;
  private iss: any; // ISS model
  private issScale: number = 0.1; // scale for the iss model
  private issMaterial: any = new THREE.MeshLambertMaterial({ color: 0xffffff }); // material for the ISS model
  private seelectMaterial: any = new THREE.MeshLambertMaterial({
    color: 0xff0000,
  }); // material for the ISS model

  private paths: any[] = new Array();
  private trackLine: any;

  private carShow: boolean = true; // we focus the this.view on the ISS once we receive our first data point
  private positionHistory: any[] = new Array(); // all ISS positions received so far
  private trackPoints: any[] = new Array(); // all ISS positions received so far
  private globalIndex: number = 0;

  private markerMaterial: any; // material for the markers left by the ISS
  private markerGeometry: any; // geometry for the markers left by the ISS
  private test: any;
  private speedText: any;
  private font: any;
  private region: any;
  private cylinder: any;
  private dataResults: any[] = new Array();
  private cars: any[] = new Array();

  private lastPosition: any;
  private lastTime: any;
  private RenderTime: any;
  private lastEntry: any;
  private graphicsLayer: any;
  private tiltAngle: number = 0;
  private external: any;
  private canDel: boolean = false;
  private selectCarid: string = "10001";
  private selectObj: any;
  private viewAnimation: string = "start";

  public constructor(
    view: __esri.SceneView,
    trackPoints: any[],
    options?: any
  ) {
    this.view = view;
    this.dataResults = trackPoints;
  }

  // Called once a custom layer is added to the map.layers collection and this layer this.view is instantiated.
  public async setup(context: any) {
    const [
      GraphicsLayer,
      externalRenderers,
      SpatialReference,
      Graphic,
    ] = await loadModules([
      "esri/layers/GraphicsLayer",
      "esri/views/3d/externalRenderers",
      "esri/geometry/SpatialReference",
      "esri/Graphic",
    ]);

    this.external = [
      GraphicsLayer,
      externalRenderers,
      SpatialReference,
      Graphic,
    ];
    this.graphicsLayer = new GraphicsLayer();
    this.view.map.add(this.graphicsLayer);

    let _this = this;
    //单击选中车辆
    this.view.on("click", (event: any) => {
      _this.getIntersects(event);
    });
    //双击地图空白处，取消选中车辆
    this.view.on("double-click", (event: any) => {
      _this.clearSelect();
    });
    this.queryISSPosition();

    let issMeshUrl = "obj/file.obj";
    if (!this.iss) {
      let loader = new OBJLoader(THREE.DefaultLoadingManager);
      loader.load(
        issMeshUrl,
        (object3d: any) => {
          console.log("ISS mesh loaded.");
          _this.iss = object3d.clone();
          for (let i = 0; i < _this.dataResults.length; i++) {
            let item = _this.dataResults[i];
            _this.updateGroupGeometry(
              {
                obj: object3d.clone(),
                id: item.id,
                pos: [121.31, 31.23, 50],
                angle: 0,
                speed: 0,
              },
              "add"
            );
          }

          // apply ISS material to all nodes in the geometry
        },
        undefined,
        (error: any) => {
          console.error("Error loading ISS mesh. ", error);
        }
      );
    }
    _this.speedText = new Graphic({
      geometry: {
        type: "point", // autocasts as new Point()
        x: 0,
        y: 0,
        z: 100,
      },
      symbol: {
        type: "text", // autocasts as new LabelSymbol3D()
        text: "车速:0km/h",
        font: {
          size: 30,
          weight: "bold",
        },
      },
    });
    // initialize the three.js renderer
    //////////////////////////////////////////////////////////////////////////////////////
    this.renderer = new THREE.WebGLRenderer({
      context: context.gl,
      premultipliedAlpha: false,
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setViewport(0, 0, this.view.width, this.view.height);

    // prevent three.js from clearing the buffers provided by the ArcGIS JS API.
    this.renderer.autoClearDepth = false;
    this.renderer.autoClearStencil = false;
    this.renderer.autoClearColor = false;

    // The ArcGIS JS API renders to custom offscreen buffers, and not to the default framebuffers.
    // We have to inject this bit of code into the three.js runtime in order for it to bind those
    // buffers instead of the default ones.
    let originalSetRenderTarget = this.renderer.setRenderTarget.bind(
      this.renderer
    );
    this.renderer.setRenderTarget = (target: any) => {
      originalSetRenderTarget(target);
      if (target == null) {
        context.bindRenderTarget();
      }
    };

    // setup the three.js scene
    ///////////////////////////////////////////////////////////////////////////////////////

    this.scene = new THREE.Scene();

    // setup the camera
    this.camera = new THREE.PerspectiveCamera();

    // setup scene lighting
    this.ambient = new THREE.AmbientLight(0xffffff, 0.5);
    this.scene.add(this.ambient);
    this.sun = new THREE.DirectionalLight(0xffffff, 0.5);
    this.scene.add(this.sun);

    // setup markers
    // cleanup after ourselfs
    context.resetWebGLState();
  }
  private async goToCarView(pos: any, angle: string | number) {
    let _this = this;
    if (this.viewAnimation == "start") {
      _this.viewAnimation = "running";
      this.view
        .goTo(
          {
            center: [pos[0], pos[1]],
            zoom: 20,
            heading: angle,
            tilt: 70,
          },
          { animate: true, duration: 1000 }
        )
        .then(() => {
          _this.viewAnimation = "finish";
        });
    } else if (this.viewAnimation == "finish") {
      this.view.goTo(
        {
          center: [pos[0], pos[1]],
          zoom: 20,
          tilt: 70,
        },
        { animate: false, duration: 500 }
      );
    }
  }
  private async updateGroupGeometry(param: any, model?: string) {
    const [
      GraphicsLayer,
      externalRenderers,
      SpatialReference,
      Graphic,
    ] = await loadModules([
      "esri/layers/GraphicsLayer",
      "esri/views/3d/externalRenderers",
      "esri/geometry/SpatialReference",
      "esri/Graphic",
    ]);
    let object3d = param.obj;
    let id = param.id;
    let posEst = param.pos;
    let angle = param.angle;
    let speed = param.speed;
    if (model == "add") {
      this.cars.push({ id: id, obj: object3d });
      object3d.name = id;
      object3d.traverse((child: any) => {
        if (child instanceof THREE.Mesh) {
          child.material = this.issMaterial;
        }
      });

      // set the specified scale for the model
      object3d.scale.set(this.issScale, this.issScale, this.issScale);
      // add the model
      this.scene.add(object3d);
    }
    if (this.selectCarid != "" && this.selectCarid == id) {
      this.goToCarView(posEst, angle);
      if (this.speedText) {
        this.graphicsLayer.removeAll();
        this.speedText = new Graphic({
          geometry: {
            type: "point", // autocasts as new Point()
            x: posEst[0],
            y: posEst[1],
            z: 10,
          },
          symbol: {
            type: "text", // autocasts as new LabelSymbol3D()
            text: "车速:" + speed + "km/h",
            font: {
              size: 30,
              weight: "bold",
            },
          },
        });
        this;
        this.graphicsLayer.add(this.speedText);
      }
    }

    let isstransform = object3d.modelViewMatrix;
    isstransform.fromArray(
      externalRenderers.renderCoordinateTransformAt(
        this.view,
        posEst,
        SpatialReference.WGS84,
        new Array(16)
      )
    );
    isstransform.decompose(
      object3d.position,
      object3d.quaternion,
      new THREE.Vector3(this.issScale, this.issScale, this.issScale)
    );

    let renderPos = [0, 0, 0];
    externalRenderers.toRenderCoordinates(
      this.view,
      posEst,
      0,
      SpatialReference.WGS84,
      renderPos,
      0,
      1
    );
    object3d.position.set(renderPos[0], renderPos[1], renderPos[2]);
    object3d.rotateX(Math.PI / 2);

    object3d.rotateY(((180 - angle) * Math.PI) / 180);
  }
  // Called every time a frame is rendered.
  public async render(context: any) {
    // update camera parameters
    ///////////////////////////////////////////////////////////////////////////////////
    const [externalRenderers, SpatialReference, Graphic] = [
      this.external[1],
      this.external[2],
      this.external[3],
    ];

    let cam = context.camera;

    this.camera.position.set(cam.eye[0], cam.eye[1], cam.eye[2]);
    this.camera.up.set(cam.up[0], cam.up[1], cam.up[2]);
    this.camera.lookAt(
      new THREE.Vector3(cam.center[0], cam.center[1], cam.center[2])
    );

    // Projection matrix can be copied directly
    this.camera.projectionMatrix.fromArray(cam.projectionMatrix);
    /////////////////////////////////////////////////////////////////////////////////////////////////////
    //this.view.environment.lighting.date = Date.now();

    let l = context.sunLight;
    this.sun.position.set(l.direction[0], l.direction[1], l.direction[2]);
    this.sun.intensity = l.diffuse.intensity;
    this.sun.color = new THREE.Color(
      l.diffuse.color[0],
      l.diffuse.color[1],
      l.diffuse.color[2]
    );

    this.ambient.intensity = l.ambient.intensity;
    this.ambient.color = new THREE.Color(
      l.ambient.color[0],
      l.ambient.color[1],
      l.ambient.color[2]
    );
    let _this = this;
    let allCarPos = _this.computeISSPosition();
    if (this.cars && this.cars.length > 0) {
      this.canDel = true;
      for (let i = 0; i < this.cars.length; i++) {
        let car = this.cars[i];
        if (allCarPos[car.id]) {
          let newPos = allCarPos[car.id];

          _this.updateGroupGeometry(
            {
              obj: car.obj,
              id: car.id,
              pos: [newPos.pos.x, newPos.pos.y, 0],
              angle: newPos.angle,
              speed: newPos.speed,
            },
            "edit"
          );
        } else {
          let delcar = this.cars.splice(i, 1);
          _this.delCarGeometry(delcar);
          i--;
        }
      }
    }
    // draw the scene
    /////////////////////////////////////////////////////////////////////////////////////////////////////

    // as we want to smoothly animate the ISS movement, immediately request a re-render
    //console.log("1");
    if (this.cars.length == 0 && this.canDel) {
      externalRenderers.remove(this.view, this);
    }
    this.renderer.resetGLState();
    this.renderer.render(this.scene, this.camera);
    externalRenderers.requestRender(this.view);
    // cleanup
    context.resetWebGLState();
  }
  private delCarGeometry(car: any) {
    if (car[0].obj) {
      this.scene.remove(car[0].obj);
      car[0].obj.traverse((item: any) => {
        if (item.type === "Mesh") {
          item.geometry.dispose();
          item.material.dispose();
        }
      });
    }
  }
  private getAllCarPos(index: number) {
    let obj: any = new Object();
    let flag = false;
    this.trackPoints.forEach((tp: any) => {
      //如果超出数组长度,返回最后一条,让车辆停止运动.
      if (index < tp.trackPoints.length) {
        let item = tp.trackPoints[index];
        obj[tp.id] = {
          pos: { x: item.pos.x, y: item.pos.y },
          time: item.time,
          vel: item.vel,
          angle: item.angle, //qqqqq,
          speed: item.speed,
        };
        flag = true;
      } else {
        //车辆走到终点
        obj[tp.id] = undefined;
      }
    }, this);
    if (flag) {
      return obj;
    } else {
      //所有车辆走到终点
      return undefined;
    }
  }
  private getAllCarTime(index: number) {
    let time: any = new Object();
    if (this.positionHistory.length == 0) {
      this.trackPoints.forEach((trackPoint: any) => {
        time[trackPoint.id] = 0;
      }, this);
    }
    let num =
      index < this.positionHistory.length
        ? index
        : this.positionHistory.length - 1;

    let item = this.positionHistory[num];
    if (item) {
      for (let carid in item) {
        if (item[carid]) {
          time[carid] = item[carid].time;
        } else {
          //如果超出数组长度,返回最后一条,让车辆停止运动.
          time[carid] = -1;
        }
      }
    }
    return time;
  }
  private getAllCarEntry(index: number) {
    let num =
      index < this.positionHistory.length
        ? index
        : this.positionHistory.length - 1;
    //获取某一条历史所有车辆时刻
    if (index == -1) {
      return this.positionHistory[this.positionHistory.length - 1];
    }
    let old = this.positionHistory[num];
    let entry = Utils.copyObject(old);
    return entry;
  }
  private computeISSPosition() {
    const [externalRenderers, SpatialReference, Graphic] = [
      this.external[1],
      this.external[2],
      this.external[3],
    ];
    if (!this.start) {
      //默认不开始移动,返回第一个坐标
      this.RenderTime = Date.now();
      if (this.positionHistory.length == 0) {
        this.lastTime = 0;
        let carStartPos = this.getAllCarPos(0);
        this.lastPosition = carStartPos;
        return carStartPos;
      } else {
        return this.lastPosition;
      }
    }
    //开始移动,转换车{carid:{pos,speed,angle,time}},往positionHistory里存入数据
    let allcarpos = this.getAllCarPos(this.globalIndex);
    if (allcarpos) {
      this.positionHistory.push(allcarpos);
      this.globalIndex++;
    }
    //返回每辆车的轨迹初始位置
    if (this.positionHistory.length == 0) {
      //返回第一个点
      this.lastTime = this.getAllCarTime(0); //初始化所有车辆time=0;
      return this.getAllCarPos(0);
    }
    //返回每辆车的轨迹初始位置,并且设置每辆车的时间
    if (this.positionHistory.length == 1) {
      //返回所有车辆的第一个轨迹点
      this.RenderTime = Date.now();
      this.lastTime = this.getAllCarTime(0);
      this.lastPosition = this.getAllCarEntry(0);
      return this.lastPosition;
    }

    // compute a new estimated position
    /////todo
    let dt1 = Date.now() - this.RenderTime;
    //console.log("dt++++++++++++", dt1);
    let entry: any = new Object();
    let carEntry: Array<string> = new Array<string>();
    //判断每辆车移动到第几个轨迹点,存到entry中
    for (let i = 1; i < this.positionHistory.length; i++) {
      let last = this.positionHistory[i];
      let count = 0;
      for (let carid in last) {
        count++;
        //判断是否已更新过轨迹点
        if (carEntry.indexOf(carid) < 0) {
          //判断是否已走完
          if (last[carid] && this.lastTime[carid] > 0) {
            if (this.lastTime[carid] + dt1 < last[carid].time) {
              entry[carid] = last[carid];
              carEntry.push(carid);
            }
          } else {
            carEntry.push(carid);
          }
        }
      }
      //判断所有车辆是否已更新轨迹完成
      if (carEntry.length == count) {
        break;
      }
    }
    //遍历所有车辆
    for (let carid in this.lastPosition) {
      if (entry[carid]) {
        if (entry[carid].time != this.lastPosition[carid].time) {
          //移动到下一个轨迹点是时
          //this.lastPosition[carid].pos = entry[carid].pos;
        }
        this.lastPosition[carid].pos = {
          x: this.lastPosition[carid].pos.x + dt1 * entry[carid].vel[0],
          y: this.lastPosition[carid].pos.y + dt1 * entry[carid].vel[1],
          z: 1,
        };
        this.lastPosition[carid].angle = entry[carid].angle;
        this.lastPosition[carid].time = entry[carid].time;
        this.lastPosition[carid].vel = entry[carid].vel;
        this.lastPosition[carid].speed = entry[carid].speed;
        //更新当前位置的时间,加上一个render时间
        this.lastTime[carid] = Number(this.lastTime[carid]) + dt1;
      } else {
        //移动到终点
        delete this.lastPosition[carid];
        // let lastentry = this.getAllCarEntry(-1);
        // this.lastTime[carid] = -1;
        // this.lastPosition[carid].pos = lastentry[carid].pos;
        // this.lastPosition[carid].stop = true;
      }
    }
    // move the current position towards the estimated position
    this.RenderTime = Date.now();
    return this.lastPosition;
  }

  /**
   * This function starts a chain of calls querying the current ISS position from open-notify.org every 5 seconds.
   */
  private async queryISSPosition() {
    let dataResults = this.dataResults;
    let paths = [];
    let speed = "";
    dataResults.forEach((data) => {
      let results = data.graphics;
      let trackPoint = [];
      for (let i = 0; i < results.length; i++) {
        let result = results[i];
        let vel = [0, 0];
        let angle = 0;
        let paths;
        if (trackPoint.length > 0) {
          let last = trackPoint[trackPoint.length - 1];
          let deltaT = result.timestamp - last.time;
          let vLon = (result.geometry.x - last.pos.x) / deltaT;
          let vLat = (result.geometry.y - last.pos.y) / deltaT;
          vel = [vLon, vLat];
          //paths = this.getTrackPoint(last.pos, result.geometry);
          speed = GetSpeed(
            last.pos.y,
            last.pos.x,
            result.geometry.y,
            result.geometry.x,
            deltaT
          );
          angle = this.doarrowAngle(last.pos, result.geometry);
        }
        trackPoint.push({
          pos: { x: Number(result.geometry.x), y: Number(result.geometry.y) },
          time: result.timestamp,
          vel: vel,
          angle: angle, //qqqqq,
          speed: speed,
        });
      }
      this.trackPoints.push({ id: data.id, trackPoints: trackPoint });
    });
    //console.log(this.trackPoints);
    // create a new marker object from the second most recent position update
    this.start = true;
  }
  private getTrackPoint(sp: any, ep: any): any {
    // var curve = new THREE.LineCurve(
    //   new THREE.Vector2(sp.x, sp.y),
    //   new THREE.Vector2(ep.x, ep.y)
    // );
    // let len = curve.getLength();
    // let sub = Math.floor(len / this.step);
    // let points = curve.getPoints(sub);
    // return points;
  }
  //车辆角度
  private doarrowAngle(p1: any, p2: any) {
    if (p2.x - p1.x == 0) {
      if (p2.y - p1.y > 0) {
        return 0;
      } else {
        return 180;
      }
    }
    if (p2.y - p1.y == 0) {
      if (p2.x - p1.x > 0) {
        return 90;
      } else {
        return 270;
      }
    }
    let angle = Math.atan2(p2.y - p1.y, p2.x - p1.x) * (180 / Math.PI);
    let px = 1,
      py = 1;
    if (p2.x > p1.x) {
      px = -1;
    }
    if (p2.y > p1.y) {
      py = -1;
    }
    return ((360 - angle + 90) % 360) - px * py * 5; //减去修正值
  }
  private clearSelect() {
    let _this = this;
    this.graphicsLayer.removeAll();
    this.selectCarid = "";
    if (this.selectObj) {
      _this.selectObj.traverse((child: any) => {
        if (child instanceof THREE.Mesh) {
          child.material = _this.issMaterial;
        }
      });
    }
  }
  private async getIntersects(event: any) {
    event.preventDefault();
    let clickObj;
    const [externalRenderers, SpatialReference] = await loadModules([
      "esri/views/3d/externalRenderers",
      "esri/geometry/SpatialReference",
    ]);
    let mp = this.view.toMap(event);
    let renderPos = [0, 0, 0];
    externalRenderers.toRenderCoordinates(
      this.view,
      [mp.longitude, mp.latitude, 0],
      0,
      SpatialReference.WGS84,
      renderPos,
      0,
      1
    );
    let _this = this;
    this.scene.children.forEach((obj: any) => {
      if (obj.type == "Group") {
        let a = _this.getDistance(
          { x: renderPos[0], y: renderPos[1], z: renderPos[2] },
          obj.position
        );
        if (a < 150 * _this.issScale) {
          if (_this.selectObj) {
            _this.selectObj.traverse((child: any) => {
              if (child instanceof THREE.Mesh) {
                child.material = _this.issMaterial;
              }
            });
          }

          clickObj = obj;
          _this.selectObj = clickObj;
          _this.selectCarid = clickObj.name;
          clickObj.traverse((child: any) => {
            if (child instanceof THREE.Mesh) {
              child.material = _this.seelectMaterial;
            }
          });
          _this.viewAnimation = "start";
        }
      }
    });
    //返回选中的对象数组
    return clickObj;
  }
  //显示隐藏显示车辆
  private toggleAllCar() {
    this.carShow = !this.carShow;
    this.scene.children.forEach((obj: any) => {
      if (obj.type == "Group") {
        obj.traverse((child: any) => {
          if (child instanceof THREE.Mesh) {
            child.material.visible = this.carShow;
          }
        });
      }
    });
  }
  private getDistance(pt1: any, pt2: any) {
    let d =
      (pt1.x - pt2.x) * (pt1.x - pt2.x) +
      (pt1.y - pt2.y) * (pt1.y - pt2.y) +
      (pt1.z - pt2.z) * (pt1.z - pt2.z);
    return Math.sqrt(d);
  }
}
